import * as PropTypes from "prop-types";

import { promisify } from "../../../utilities";
import { useState } from "react";

import * as piasu from "../NonComponents/PIAppStateUtil";
import * as gbu from "../../GB/GBUtil";
import * as gbtu from "../../GB/GBTableUtil";
import * as pisc from "../NonComponents/PIServerConst";
import * as pitu from "../NonComponents/PITableUtil";
import * as piu from "../NonComponents/PIUtil";

import { RS } from "../../../data/strings/global";
import * as SC from "../../../data/strings/PIStringConst";

import * as Theme from "../../../app/Theme";

import { generateTypes } from "../../../utilities";
import SuperTableShim from "../../common/SuperTableShim";

import {
  combinePriorPops,
  disaggregatePriorPops,
  genAndKeyPopsCombinedPops,
  combinedPopsByCategory,
} from "../NonComponents/PIPriorPopUtil";
import React from "react";

const PIMethodMixCoverageKPPSETable = (props) => {
  console.log("PIMethodMixCoverageKPPSETable");
  const onModVarsChange = promisify(props.onModVarsChange);

  const modVarObjList = props.modVarObjList;

  /** @type {any[]} */
  const methods = piasu.getModVarValue(modVarObjList, "PI_Methods");
  /** @type {any[]} */
  const allPops = piasu.getModVarValue(modVarObjList, "PI_PriorityPop");
  let priorPops = allPops;

  let baseMethodMixCoverage = piasu.getModVarValue(modVarObjList, "PI_BaseMethodMixCoverage");
  console.log("Base Method Mix Coverage", baseMethodMixCoverage);

  let endlineMethodMixCoverage = piasu.getModVarValue(modVarObjList, "PI_EndlineMethodMixCoverage");
  // console.log("Endline Method Mix Coverage", endlineMethodMixCoverage);

  /** @type {any[]} */
  let actualCoverage = piasu.getModVarValue(modVarObjList, "PI_ActualCoverage");
  let eligibility = piasu.getModVarValue(modVarObjList, "PI_Eligibility");

  const categories = Object.keys(piu.pseIncidenceCategories);
  const genAndKeyPopsWithCategories = combinedPopsByCategory(genAndKeyPopsCombinedPops, allPops, categories);

  const combined = combinePriorPops(modVarObjList, genAndKeyPopsWithCategories, [
    // "PI_BaseMethodMixCoverage",
    // "PI_EndlineMethodMixCoverage",
    "PI_ActualCoverage",
    "PI_Eligibility",
  ]);
  // baseMethodMixCoverage = combined["PI_BaseMethodMixCoverage"];
  // endlineMethodMixCoverage = combined["PI_EndlineMethodMixCoverage"];
  priorPops = combined["PI_PriorityPop"];
  actualCoverage = combined["PI_ActualCoverage"];
  eligibility = combined["PI_Eligibility"];

  const gainsboroBase10 = gbu.toBase10(gbu.getDelphiHexFromHexColor(Theme.whisperGrayTableColor));
  const badNumberFontColor = gbu.toBase10(gbu.getDelphiHexFromHexColor(Theme.red));

  const numPops = Object.keys(genAndKeyPopsCombinedPops).length;

  const numRows = 4;
  let numCols = 3;
  if (props.showActualCoverage) numCols += methods.length + 1;

  const firstRow = 1;
  const baseCategoryCol = 1;
  const firstActualCovMethod = 3;
  const endlineCategoryCol = 2;

  // State
  const [rDec, setRDecs] = useState([]);

  const isPSEMode = piasu.isPSEMode(modVarObjList);
  if (!isPSEMode) {
    return <div>PIMethodMixCoverageKPPSETable requires PSE mode</div>;
  }

  // Callbacks
  const onPackTableChange = async (newPackTable) => {
    setRDecs(structuredClone(newPackTable.RDec));

    const newEndlineCoverage = structuredClone(
      piasu.getModVarValue(modVarObjList, "PI_EndlineMethodMixCoverage")
    );
    const highIncidenceCategory = 1;
    let pp = 2;
    let row = 1;
    for (const popID in genAndKeyPopsCombinedPops) {
      if (popID === "POP_GENPOP_F" || popID === "POP_GENPOP_M") {
        continue;
      }

      const catPopID = `${popID}_${categories[highIncidenceCategory].toUpperCase()}`;
      const pop = priorPops.find((p) => p.mstID === catPopID);
      if (pop) {
        const value = gbtu.getValue(newPackTable, row, endlineCategoryCol);
        newEndlineCoverage[highIncidenceCategory][pp] = typeof value === "number" ? value / 100 : 0.0;
      }

      ++pp;
      ++row;
    }

    const newModVars = structuredClone(modVarObjList);

    const newData = {
      PI_PriorityPop: priorPops,
      // PI_BaseMethodMixCoverage: newBaseCoverage,
      // PI_EndlineMethodMixCoverage: newEndlineCoverage,
    };

    // const disagg = disaggregatePriorPops(modVarObjList, newData, genAndKeyPopsWithCategories);
    // newBaseCoverage = disagg.PI_BaseMethodMixCoverage;
    // newEndlineCoverage = disagg.PI_EndlineMethodMixCoverage;

    // piasu.setModVarValue(newModVars, "PI_BaseMethodMixCoverage", newBaseCoverage);
    console.log("New Endline Coverage", newEndlineCoverage);
    piasu.setModVarValue(newModVars, "PI_EndlineMethodMixCoverage", newEndlineCoverage);

    await onModVarsChange(newModVars, false);
  };

  // Table
  const packTable = gbtu.resizePackTable(gbtu.getNewPackTable(), numRows, numCols);

  // Headings
  // gbtu.setFixedRows(packTable, 2);

  gbtu.setValue(packTable, 0, baseCategoryCol, "Baseline Coverage"); //RS(SC.GB_stTargetCoverage))

  gbtu.setValue(packTable, 0, endlineCategoryCol, "Endline Coverage"); //RS(SC.GB_stTargetCoverage));;

  if (props.showActualCoverage) {
    gbtu.mergeCells(packTable, 0, firstActualCovMethod, 1, methods.length + 1);
    gbtu.setValue(packTable, 0, firstActualCovMethod, RS(SC.GB_stActualCovToBeAchieved) + " (%)");

    for (let m = 0; m < methods.length; ++m) {
      gbtu.setValue(packTable, 1, m + firstActualCovMethod, methods[m].name);
    }

    gbtu.setValue(packTable, 1, numCols - 1, RS(SC.GB_stTotal));
  }

  gbtu.setValue(packTable, 1, 0, RS(SC.GB_stPriorityPop));
  gbtu.setValue(packTable, 1, 1, RS(SC.GB_stCoverage));
  // console.log(baseMethodMixCoverage);
  // Data
  let pp = 2;
  let row = 1;
  for (const popID in genAndKeyPopsCombinedPops) {
    if (popID === "POP_GENPOP_F" || popID === "POP_GENPOP_M") {
       continue;
    }
    gbtu.setValue(packTable, row, 0, genAndKeyPopsCombinedPops[popID].newPopName());
    let col = baseCategoryCol;
    let cat = 1;
    {
      const catName = categories[cat];
      const catPopID = `${popID}_${catName.toUpperCase()}`;
      const pop = priorPops.find((p) => p.mstID === catPopID);
      console.log(cat, pp, baseMethodMixCoverage?.[cat]?.[pp]);
      const baseCoverage = baseMethodMixCoverage?.[cat]?.[pp] ?? 1.0;

      gbtu.lockCell(packTable, row, col, true, true);
      if (pop) {
        gbtu.setValue(packTable, row, col, baseCoverage * 100);
      } else {
        gbtu.setCellBGColor(packTable, row, col, gainsboroBase10);
      }
      ++col;
    }

    cat = 1;
    {
      const catName = categories[cat];
      const catPopID = `${popID}_${catName.toUpperCase()}`;
      const pop = priorPops.find((p) => p.mstID === catPopID);
      // console.log(catPopID, pop, endlineMethodMixCoverage?.[catPopID]);
      const endlineCoverage = endlineMethodMixCoverage?.[cat]?.[pp] ?? 1.0;

      if (pop) {
        gbtu.setValue(packTable, row, col, endlineCoverage * 100);
      } else {
        gbtu.setCellBGColor(packTable, row, col, gainsboroBase10);
        gbtu.lockCell(packTable, row, col, true, true);
      }
      ++col;
    }

    // console.log({show:props.showActualCoverage, actual:actualCoverage, eligibility:eligibility});
    if (props.showActualCoverage) {
      // Actual Coverage
      let disableTotal = true;
      let actTotal = 0.0;

      for (let m = 0; m < methods.length; ++m) {
        const method = methods[m];

        if (piasu.getPriorPopMethodElig(eligibility, method.mstID, pp + 1) === pisc.yesMstID) {
          const actualValue = actualCoverage[m].coverage[pp] * 100;
          gbtu.setValue(packTable, pp + firstRow, m + firstActualCovMethod, actualValue);
          actTotal += actualValue;

          disableTotal = false;
        } else {
          gbtu.setCellBGColor(packTable, pp + firstRow, m + firstActualCovMethod, gainsboroBase10);
        }

        gbtu.lockCell(packTable, pp + firstRow, m + firstActualCovMethod, true, true);
      }

      // Total
      if (!disableTotal) {
        gbtu.setValue(packTable, row, numCols - 1, actTotal);
        gbtu.lockCell(packTable, row, numCols - 1, true, actTotal <= 100);
        if (actTotal > 100) gbtu.setFontColor(packTable, row, numCols - 1, badNumberFontColor);
      } else {
        // Grey out Total
        gbtu.lockCell(packTable, row, numCols - 1, true, true);
        gbtu.setCellBGColor(packTable, row, numCols - 1, gainsboroBase10);

        // Grey out Coverage
        gbtu.lockCell(packTable, row, 1, true, true);
        gbtu.setCellBGColor(packTable, row, 1, gainsboroBase10);
      }
    }

    ++pp;
    ++row;
  }

  // Settings
  gbtu.alignNumericCellsRight(packTable);
  // gbtu.setRowAlignment(packTable, 0, gbtc.hAlign.center);
  gbtu.setMinAllowedValForTable(packTable, 0);
  gbtu.setMaxAllowedValForTable(packTable, 100);
  gbtu.setColWidths(packTable, Theme.dataColWidthSmall);
  gbtu.setColWidth(packTable, 0, Theme.itemNameColWidthWide);
  gbtu.setRowHeight(packTable, 0, 50);
  gbtu.setWordWrappedCol(packTable, 0, true);
  gbtu.setID(packTable, "optionsPackTable");
  gbtu.setKey(packTable, "optionsPackTable");

  gbtu.setRDecs(packTable, 1);
  if (rDec.length !== 0) {
    for (let r = 0; r < rDec.length; r++) {
      for (let c = 0; c < rDec[r].length; c++) {
        gbtu.setRDec(packTable, r, c, rDec[r][c]);
      }
    }
  }

  return (
    // @ts-ignore
    <SuperTableShim
      // focusedCell={state[pip.focusedCell]}
      // onCellFocused={(focusedCell) => pitu.onCellFocused(this, focusedCell)}
      // selectedRegions={state[pip.selectedRegions]}
      // onSelectionChanged={(selectedRegions) => pitu.onSelectionChanged(this, selectedRegions)}
      font={Theme.tableFont}
      headerBackgroundColor={Theme.PI_PrimaryColor}
      gridKey={props.tableKey}
      oddRowBackgroundColor={Theme.PI_BandColor}
      packTable={packTable}
      types={generateTypes(packTable)}
      onPackTableChanged={onPackTableChange}
      removedMenuNames={pitu.tableHideMenuItems}
      style={{
        fontFamily: Theme.tableFont,
        marginTop: Theme.ctrlSpacing,
        padding: 0,
      }}
      undoDisabled={false}
    />
  );
};

PIMethodMixCoverageKPPSETable.propTypes = {
  modVarObjList: PropTypes.array.isRequired,
  onModVarsChange: PropTypes.func,
  tableKey: PropTypes.string,
  showActualCoverage: PropTypes.bool,
};

PIMethodMixCoverageKPPSETable.defaultProps = {
  onModVarsChange: () => {},
  tableKey: "",
  showActualCoverage: false,
};

export default PIMethodMixCoverageKPPSETable;
